import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Alert,
} from "@mui/material";
import { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

const NewGharNo = () => {
  const { state } = useLocation();
  const tollId = state?.tollId;

  const userId = useSelector((state) => state.user.userId);
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();

  const [count, setCount] = useState(1);
  const [gharList, setGharList] = useState([{ gharNo: "", gharOwnerName: "" }]);
  const [errors, setErrors] = useState([]);
  const [submitError, setSubmitError] = useState("");

  const handleCountChange = (value) => {
    const number = parseInt(value) || 0;
    setCount(number);

    const newArray = Array.from({ length: number }, () => ({
      gharNo: "",
      gharOwnerName: "",
    }));

    setGharList(newArray);
    setErrors([]);
  };

  const handleChange = (index, field, value) => {
    const updated = [...gharList];
    updated[index][field] = value;
    setGharList(updated);
  };

  const validate = () => {
    const newErrors = [];

    gharList.forEach((item, index) => {
      const itemErrors = {};
      if (!item.gharNo.trim()) itemErrors.gharNo = "Ghar No is required";
      if (!item.gharOwnerName.trim())
        itemErrors.gharOwnerName = "Owner Name is required";

      newErrors[index] = itemErrors;
    });

    setErrors(newErrors);

    return newErrors.every((err) => !err?.gharNo && !err?.gharOwnerName);
  };

  const handleSubmit = async () => {
    setSubmitError("");

    if (!validate()) {
      setSubmitError("Please fill all required fields.");
      return;
    }

    try {
      await axios.post(`${BASE_URL}/api/gharNo/addGharNo`, {
        userId,
        tollId,
        gharNos: gharList,
      });

      navigate("/gharNo");
    } catch (err) {
      setSubmitError("Something went wrong. Try again.");
    }
  };

  return (
    <div className="newUser">
      <Sidebar />
      <div className="newUserContainer">
        <Navbar />

        <Box sx={{ padding: 4 }}>
          <Paper elevation={3} sx={{ padding: 4 }}>
            <Typography variant="h5" fontWeight="bold">
              Add Multiple Ghar No
            </Typography>

            <TextField
              label="How many Ghar?"
              type="number"
              value={count}
              onChange={(e) => handleCountChange(e.target.value)}
              sx={{ mt: 3 }}
              fullWidth
            />

            {gharList.map((item, index) => (
              <Box key={index} sx={{ display: "flex", gap: 2, mt: 3 }}>
                <TextField
                  label="Ghar No"
                  fullWidth
                  value={item.gharNo}
                  error={!!errors[index]?.gharNo}
                  helperText={errors[index]?.gharNo}
                  onChange={(e) =>
                    handleChange(index, "gharNo", e.target.value)
                  }
                />
                <TextField
                  label="Owner Name"
                  fullWidth
                  value={item.gharOwnerName}
                  error={!!errors[index]?.gharOwnerName}
                  helperText={errors[index]?.gharOwnerName}
                  onChange={(e) =>
                    handleChange(index, "gharOwnerName", e.target.value)
                  }
                />
              </Box>
            ))}

            {submitError && (
              <Alert severity="error" sx={{ mt: 3 }}>
                {submitError}
              </Alert>
            )}

            <Button
              variant="contained"
              size="large"
              sx={{ mt: 4 }}
              fullWidth
              onClick={handleSubmit}
            >
              Submit All
            </Button>
          </Paper>
        </Box>
      </div>
    </div>
  );
};

export default NewGharNo;
